export default __webpack_public_path__ + "static/media/benefits_4.e811147d.png";